export interface ForgotGuardianPassword {
  email: string
  refSource: string
}

/**
 * Enum representing different types of contacts related to a scholar.
 * @enum {string}
 */
export enum ScholarContactType {
  GUARDIAN = 'guardian',
  EMERGENCY_CONTACT = 'emergency-contact',
  AUTHORIZED_PICKUP = 'authorized-pickup'
}
